
(function () {
  'use strict';
// Muta i log [sov-stories] se non esplicitamente abilitati
if (!window.SOV_STORIES_DEBUG) {
  ['debug','info','log'].forEach(function (k) {
    var orig = console[k];
    console[k] = function () {
      var msg = arguments[0];
      if (typeof msg === 'string' && msg.indexOf('[sov-stories]') === 0) return;
      return orig.apply(console, arguments);
    };
  });
}
// Per riattivare i log: window.SOV_STORIES_DEBUG = true (prima di caricare lo script)

  // LOG AVVIO
  console.info('[sov-stories] bootstrap globale caricato');

  var SELECTOR = '.sov-story-li[data-sov-stories-uid]';

  function initStories(root) {
    try {
      console.debug('[sov-stories] initStories su', root);

      var resumeTimer = null;
var AUTOPLAY_RESUME_MS = 500;

function bumpAutoplay(){
  // pausa subito, poi riparte dopo AUTOPLAY_RESUME_MS (per evitare rimbalzi animazione)
  pause();
  if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
  resumeTimer = setTimeout(function(){
    play();
    resumeTimer = null;
  }, AUTOPLAY_RESUME_MS);
}

      var track = root.querySelector('.sov-stories__slides');
      var bars = Array.prototype.slice.call(root.querySelectorAll('.sov-stories__bar > i'));
      var btnPrev = root.querySelector('.sov-stories__tap--prev');
      var btnNext = root.querySelector('.sov-stories__tap--next');
      var btnToggle = root.querySelector('.sov-stories__toggle');
      var slides = Array.prototype.slice.call(root.querySelectorAll('.sov-story'));

      if (!track || slides.length === 0) {
        console.warn('[sov-stories] strutture mancanti, salto', {trackOk: !!track, slides: slides.length});
        return;
      }
      /* --------------------------------------------------------------------
         SOV — randomizzazione quantità (K) e ordine slide lato client
         -Ultimo aggiornamento: 2025-09-06 20:55 (Europe/Rome)
         Before: ordine/quantità fissi in base a HTML arrivato
         After:  ad ogni init: K = 1 se N=1 altrimenti random 2..N; ordine shuffle
      -------------------------------------------------------------------- */
      (function randomizeSlidesOrderAndCount(){
        var N = slides.length;                   // N ≤ 8 (pageSize server)
        if (N === 0) return;

        // 1) determina K (quante slide mostrare)
        var K = (N === 1) ? 1 : (2 + Math.floor(Math.random() * (N - 1)));  // 2..N

        // 2) shuffle (Fisher–Yates) sull'array slides
        for (var i = N - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = slides[i]; slides[i] = slides[j]; slides[j] = tmp;
        }

        // 3) riordina il DOM secondo lo shuffle
        for (var r = 0; r < N; r++) track.appendChild(slides[r]);

        // 4) rimuovi le slide oltre K
        for (var k = K; k < N; k++) {
          if (slides[k] && slides[k].parentNode === track) track.removeChild(slides[k]);
        }

        // 5) ricostruisci le progress bar in base a K
        var prog = root.querySelector('.sov-stories__progress');
        if (prog) {
          if (K > 1) {
            // reset e rebuild
            prog.innerHTML = '';
            for (var b = 0; b < K; b++) {
              var bar = document.createElement('div');
              bar.className = 'sov-stories__bar';
              var iEl = document.createElement('i');
              bar.appendChild(iEl);
              prog.appendChild(bar);
            }
          } else {
            // con una sola slide, niente progress
            prog.parentNode && prog.parentNode.removeChild(prog);
          }
        }

        // 6) se K <= 1: niente prev/next/toggle e loop off
        if (K <= 1) {
          var prev = root.querySelector('.sov-stories__tap--prev');
          var next = root.querySelector('.sov-stories__tap--next');
          var tog  = root.querySelector('.sov-stories__toggle');
          if (prev) prev.remove();
          if (next) next.remove();
          if (tog)  tog.remove();
          root.setAttribute('data-sov-loop', 'false');
        }

        // 7) rilegge i riferimenti aggiornati
        slides = Array.prototype.slice.call(root.querySelectorAll('.sov-story'));
        bars   = Array.prototype.slice.call(root.querySelectorAll('.sov-stories__bar > i'));
      })();
      if (!track.style.transition) track.style.transition = 'transform .35s ease';
      root.removeAttribute('hidden');

      var idx = 0;
            /* --------------------------------------------------------------------
         sov — loop continuo con cloni sentinella
         -ultimo aggiornamento: 2025-09-12 16:45 (europe/rome)
         before: loop con salto visibile (idx N-1 → 0)
         after:  duplica prima/ultima slide e usa “snap invisibile” su transitionend
      -------------------------------------------------------------------- */
      /* --------------------------------------------------------------------
         sov — loop continuo con buffer di cloni (testa+coda)
         -ultimo aggiornamento: 2025-09-12 18:05 (europe/rome)
         before: 1 clone in testa (ultima) + 1 clone in coda (prima)
         after:  buffer simmetrico configurabile (CLONE_BUFFER) per scorrere
                 anche “all’indietro” fin dall’avvio senza jump
      -------------------------------------------------------------------- */
      var K = slides.length;               // numero slide reali (e barre)
      var hasLoopClones = false;
      var loopAttr = String(root.getAttribute('data-sov-loop') || 'true') === 'true';
      var CLONE_BUFFER = 1;                // aumentare a 2 per più corsa

      if (loopAttr && K > 1) {
        // crea cloni di testa (ultime B) e di coda (prime B)
        var headCount = Math.min(CLONE_BUFFER, K);
        var tailCount = Math.min(CLONE_BUFFER, K);

        // cloni di testa: prende le ultime 'headCount' e le inserisce in ordine al front
        for (var h = headCount; h > 0; h--) {
          var nodeHead = slides[K - h].cloneNode(true);
          track.insertBefore(nodeHead, track.firstChild);
        }
        // cloni di coda: prende le prime 'tailCount' e le appende in ordine
        for (var t = 0; t < tailCount; t++) {
          var nodeTail = slides[t].cloneNode(true);
          track.appendChild(nodeTail);
        }

        slides = Array.prototype.slice.call(root.querySelectorAll('.sov-story'));
        hasLoopClones = true;
      }



      var autoplayMs = parseInt(root.getAttribute('data-sov-autoplay-ms') || '5000', 10);
      var loop = String(root.getAttribute('data-sov-loop') || 'true') === 'true';
      var paused = false, t0 = null, raf = null;

      // mappa indice track (0..K+2B-1) → indice barra reale (0..K-1)
      function currentBarIndex() {
        if (!hasLoopClones) return idx;
        var B = CLONE_BUFFER;
        var total = K + 2 * B;
        if (idx < B)          return (K - (B - idx));  // nella fascia head-clones
        else if (idx >= K + B) return (idx - (K + B)); // nella fascia tail-clones
        else                   return (idx - B);       // fascia reale
      }

      function fireStoriesSwap(direction){
  if (typeof window.gtag !== 'function' || !K) return;

  var fromIdx = (typeof currentBarIndex === 'function') ? currentBarIndex() : 0;
  var toIdx   = direction === 'next' ? (fromIdx + 1) % K : (fromIdx - 1 + K) % K;

  window.gtag('event', direction === 'next' ? 'stories_swap_next' : 'stories_swap_prev', {
    story_index_from: fromIdx,
    story_index_to: toIdx,
    stories_uid: root.getAttribute('data-sov-stories-uid') || null,
    source_filter: root.getAttribute('data-sov-stories-source-filter') || null,
    source_page: parseInt(root.getAttribute('data-sov-stories-source-page') || '0', 10)
  });
}

// Telemetria: click sul link verticale (label ruotata)
(function(){
  var label = root.querySelector('.sov_stories_filter_label--link');
  if (!label) return;

  label.addEventListener('click', function(ev){
    try{
      if (typeof window.gtag === 'function') {
        var openNew = (ev.button === 1 || ev.ctrlKey || ev.metaKey || ev.shiftKey);
        window.gtag('event', 'stories_vertical_link_click', {
          href: label.href || null,
          label_text: (label.textContent || '').trim() || null,
          open_in: openNew ? 'new_tab' : 'same_tab',
          stories_uid: root.getAttribute('data-sov-stories-uid') || null,
          source_filter: root.getAttribute('data-sov-stories-source-filter') || null,
          source_page: parseInt(root.getAttribute('data-sov-stories-source-page') || '0', 10)
        });
      }
    }catch(_){}
  }, true); // capture: scatta prima della navigazione
})();

      function go(i) {
        var prevIdx = idx;

        if (!hasLoopClones) {
          if (i < 0) i = loop ? slides.length - 1 : 0;
          if (i >= slides.length) i = loop ? 0 : slides.length - 1;
        } else {
          var B = CLONE_BUFFER;
          var min = 0;
          var max = K + 2 * B - 1; // ultimo indice consentito
          if (i < min) i = min;
          if (i > max) i = max;
        }

        idx = i;
        track.style.transform = 'translateX(' + (-100 * idx) + '%)';

        var bi = currentBarIndex();
        for (var k2 = 0; k2 < bars.length; k2++) {
          bars[k2].style.width = (k2 < bi) ? '100%' : '0%';
        }

        // dispatch unificato
        try {
          var direction = (idx > prevIdx) ? 'next' : (idx < prevIdx ? 'prev' : 'stay');
          var ev = new CustomEvent('sov:stories:navigate', {
            detail: { reason: 'unknown', direction: direction, root: root }
          });
          document.dispatchEvent(ev);
        } catch(_) {}

        t0 = performance.now();
        tick();
      }


      function tick(now) {
        if (paused || bars.length === 0) return;
        if (t0 == null) t0 = now || performance.now();

        var elapsed = (now || performance.now()) - t0;
        var p = Math.max(0, Math.min(1, elapsed / autoplayMs));

        var bi = currentBarIndex();
        if (bars[bi]) bars[bi].style.width = (p * 100).toFixed(3) + '%';

        if (p >= 1) {
          if (!hasLoopClones) {
            if (idx < slides.length - 1 || loop) {
              go(idx + 1);
            } else {
              if (bars[bi]) bars[bi].style.width = '100%';
              cancelAnimationFrame(raf); raf = null; return;
            }
          } else {
            // con cloni, si può sempre avanzare fino a K+1 (sentinella)
            go(idx + 1);
          }
        }
        raf = requestAnimationFrame(tick);
      }
      /* sov — snap invisibile su estremi (solo con cloni) */
      track.addEventListener('transitionend', function (e) {
        if (!hasLoopClones) return;
        if (!e || e.propertyName !== 'transform') return;

        var B = CLONE_BUFFER;

        if (idx < B) {
          var prev = track.style.transition || '';
          track.style.transition = 'none';
          idx = idx + K;
          track.style.transform = 'translateX(' + (-100 * idx) + '%)';
          void track.offsetHeight;
          track.style.transition = prev || 'transform .35s ease';
        } else if (idx >= K + B) {
          var prev2 = track.style.transition || '';
          track.style.transition = 'none';
          idx = idx - K;
          track.style.transform = 'translateX(' + (-100 * idx) + '%)';
          void track.offsetHeight;
          track.style.transition = prev2 || 'transform .35s ease';
        }
      }, true);




      function play() {
        if (!paused && raf) return;
        paused = false;
        if (btnToggle) btnToggle.setAttribute('aria-pressed', 'false');
        var bw = 0;
        if (bars[idx] && typeof bars[idx].style.width === 'string') {
          var n = parseFloat(bars[idx].style.width);
          bw = isNaN(n) ? 0 : n;
        }
        if (raf) { cancelAnimationFrame(raf); raf = null; }
        t0 = performance.now() - (bw / 100) * autoplayMs;
        raf = requestAnimationFrame(tick);
      }

function pause() {
  paused = true;
  if (btnToggle) btnToggle.setAttribute('aria-pressed', 'true');
  if (raf) { cancelAnimationFrame(raf); raf = null; }
  if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; } // <— nuovo 4 ottobre 2025 ore 17.02
}

if (btnPrev) btnPrev.addEventListener('click', function (ev) {
  ev.preventDefault(); ev.stopPropagation();
  go(idx - 1);
  bumpAutoplay();
});
if (btnNext) btnNext.addEventListener('click', function (ev) {
  ev.preventDefault(); ev.stopPropagation();
  go(idx + 1);
  bumpAutoplay();
});
      if (btnToggle) btnToggle.addEventListener('click', function () { (paused ? play : pause)(); });

            /* --------------------------------------------------------------------
         sov — stories: swipe/drag orizzontale per prev/next
         -ultimo aggiornamento: 2025-09-12 16:25 (europe/rome)
         before: navigazione solo via tap
         after:  supporto pointer/touch/mouse drag con snap e ripresa autoplay
      -------------------------------------------------------------------- */
      (function enableSwipeNavigation(){
  var viewport = root.querySelector('.sov-stories__viewport');
  if (!viewport) return;

  // Unico elenco di target "interattivi" da NON trattare come swipe
  var INTERACTIVE_SEL = 'a,button,input,select,textarea,.sov-stories__tap,.sov-story__pill,.sov_stories_filter_label';

  // Stop al drag nativo (ancore/immagini) su tutti i puntatori
  viewport.addEventListener('dragstart', function(ev){ ev.preventDefault(); }, true);

  var dragging = false, captured = false;
  var startX = 0, dx = 0, vw = 1, prevTransition = '';
  var suppressClickUntil = 0;

  function onDown(ev){
    var t = (ev.touches && ev.touches[0]) || ev;
    if (!t) return;

  //  NON bloccare se il target è un tap overlay (vogliamo lo swipe da lì)
  if (ev.target && ev.target.closest(INTERACTIVE_SEL) && !ev.target.closest('.sov-stories__tap')) {
    return; // pill, label, link, input... lasciano passare il click nativo
  }

    dragging = true;
    captured = false;
    startX = t.clientX;
    dx = 0;
    vw = viewport.clientWidth || root.getBoundingClientRect().width || 1;

    // Pausa autoplay e segui il dito senza easing
    pause();
    prevTransition = track.style.transition || '';
    track.style.transition = 'none';
    track.style.willChange = 'transform';
  }

  function onMove(ev){
    if (!dragging) return;
    var t = (ev.touches && ev.touches[0]) || ev;
    if (!t) return;

    dx = t.clientX - startX;

    // Cattura il puntatore SOLO quando è davvero un drag (soglia 8px)
    if (!captured && Math.abs(dx) > 8) {
      try { viewport.setPointerCapture && viewport.setPointerCapture(ev.pointerId); } catch(_){}
      captured = true;
    }

    // Muovi il track solo quando si è superata la soglia
    if (Math.abs(dx) > 8){
      var offsetPct = (dx / (vw || 1)) * 100;
      track.style.transform = 'translateX(' + (-100 * idx + offsetPct) + '%)';
      if (ev.cancelable) ev.preventDefault();
    }
  }

  function onUp(ev){
    if (!dragging) return;
    dragging = false;

    track.style.transition = prevTransition || 'transform .35s ease';
    track.style.willChange = '';

    var thresholdPx = Math.max(40, vw * 0.15);
    var advance = Math.abs(dx) >= thresholdPx ? (dx < 0 ? +1 : -1) : 0;

    if (advance){
      suppressClickUntil = performance.now() + 250; // evita ghost-click
      var dir = advance > 0 ? 'next' : 'prev';
      fireStoriesSwap(dir);      
      go(idx + advance);
      bumpAutoplay();

    } else {
      go(idx);
      bumpAutoplay();
    }
    //play();

    if (captured) {
      try { viewport.releasePointerCapture && viewport.releasePointerCapture(ev.pointerId); } catch(_){}
    }
    dx = 0;
  }

  // Kill ghost-click solo se appena avvenuto uno swipe
  viewport.addEventListener('click', function(ev){
    if (performance.now() < suppressClickUntil){
      ev.preventDefault(); ev.stopPropagation();
    }
  }, true);

  // Unico set di listener (vale per mouse, touch, pen)
  viewport.addEventListener('pointerdown',   onDown, { passive: true  });
  viewport.addEventListener('pointermove',   onMove, { passive: false });
  viewport.addEventListener('pointerup',     onUp,   { passive: true  });
  viewport.addEventListener('pointercancel', onUp,   { passive: true  });
})();



      try {
        var io = new IntersectionObserver(function (es) {
          var vis = es.some ? es.some(function(e){return e.isIntersecting;}) : es[0] && es[0].isIntersecting;
          if (vis) play(); else pause();
        }, { threshold: 0.25 });
        io.observe(root);
      } catch(_) {}

      var startIdx = hasLoopClones ? CLONE_BUFFER : 0; // parte già dopo i cloni di testa
      go(startIdx);
      play();
      console.debug('[sov-stories] initStories OK', { uid: root.getAttribute('data-sov-stories-uid'), clones: hasLoopClones, K: K });

    } catch (err) {
      console.error('[sov-stories][initStories] errore', err);
    }
  }

  function initOne(root){
    if (!root || root.__sovStoriesInited) return;
    root.__sovStoriesInited = true;
    console.debug('[sov-stories] initOne', root);
    initStories(root);
  }

  function initAll(){
    var nodes = document.querySelectorAll(SELECTOR);
    if (!nodes.length) {
      console.debug('[sov-stories] initAll: nessun nodo trovato al momento');
      return;
    }
    console.debug('[sov-stories] initAll: trovati', nodes.length, 'nodi');
    for (var i = 0; i < nodes.length; i++) initOne(nodes[i]);
  }

  // Eventi “ufficiali” delle tue iniezioni (se li emetti)
  document.addEventListener('sov:edb:mounted', function(ev){
    var li = ev && ev.detail && ev.detail.root;
    console.debug('[sov-stories] sov:edb:mounted', { li: !!li });
    if (!li) return;
    if (li.matches && li.matches(SELECTOR)) initOne(li);
    else if (li.querySelector) {
      var candidate = li.querySelector(SELECTOR);
      if (candidate) initOne(candidate);
    }
  });

  // Fallback iniziali e lifecycle
  document.addEventListener('DOMContentLoaded', function(){ console.debug('[sov-stories] DOMContentLoaded'); initAll(); }, { once: true });
  window.addEventListener('load', function(){ console.debug('[sov-stories] load'); initAll(); }, { once: true });
  setTimeout(initAll, 120);
  setTimeout(initAll, 400);
  setTimeout(initAll, 1200);

  // Osserva nuove iniezioni nel DOM (rete di sicurezza)
  try{
    var target = document.getElementById('product-grid') || document.body;
    var mo = new MutationObserver(function(muts){
      var hasNew = false;
      for (var m of muts) {
        if (m.addedNodes && m.addedNodes.length) { hasNew = true; break; }
      }
      if (hasNew) {
        console.debug('[sov-stories] MutationObserver: nuove aggiunte, provo initAll()');
        initAll();
      }
    });
    mo.observe(target, { childList: true, subtree: true });
    console.debug('[sov-stories] MutationObserver attivo su', target);
  } catch(e){
    console.warn('[sov-stories] MutationObserver non disponibile', e);
  }

})();
/* SOV — Stories: centra la label verticale a metà card */
(function () {
  'use strict';

  function centerLabel(vp) {
    var el = vp && vp.querySelector('.sov_stories_filter_label');
    if (!el) return;

    var h = vp.getBoundingClientRect().height;
    el.style.top = Math.round(h / 1.8) + 'px';
    //el.style.transformOrigin = 'left center';
    //el.style.transform = 'translateY(-50%) rotate(-90deg)'; // centra prima, ruota poi
    
    // el.style.left = '1.4rem';
  }

  function bindOne(root) {
    var vp = root && (root.querySelector
      ? root.querySelector('.sov-stories__viewport')
      : null);
    if (!vp) return;

    centerLabel(vp);

    // ricalcola se la card cambia dimensione (responsive/img load)
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function(){ centerLabel(vp); });
      ro.observe(vp);
    }
    vp.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', function(){ centerLabel(vp); }, { once: true });
    });
  }

  function bindAll(scope) {
    (scope || document).querySelectorAll('.sov-story-li').forEach(bindOne);
  }

  // iniziale
  bindAll(document);

  // quando inietti una nuova stories card
  document.addEventListener('sov:edb:mounted', function (e) {
    var root = (e && e.detail && e.detail.root) || e.target;
    bindAll(root || document);
  });

  // sicurezza su resize/orientation
  window.addEventListener('resize', function(){ bindAll(document); }, { passive: true });
  window.addEventListener('orientationchange', function(){ bindAll(document); }, { passive: true });
})();
